<template>
  <div class="container">
    <div style="background: #cab586">
      <van-search
        v-model="value"
        shape="round"
        background="#CAB586"
        placeholder="搜索商品"
        @search="checkres"
      />
      <div class="top">
        <img :src="headimg" class="avatar" alt="" />
        <div>
          <p style="font-size: 14px">当前积分</p>
          <p style="font-size: 36px; font-weight: bold">
            {{ mypoint }}<span style="font-size: 14px">分</span>
          </p>
        </div>
        <div class="dhbt" @click="$router.push('/jfrecord')">兑换记录></div>
      </div>
    </div>
    <div class="main">
      <div class="flex">
        <div class="tab" :class="{ active: num == 1 }" @click="num = 1">
          全部
        </div>
        <div class="tab" :class="{ active: num == 2 }" @click="num = 2">
          实物
        </div>
        <div class="tab" :class="{ active: num == 3 }" @click="num = 3">
          虚拟
        </div>
        <div class="tab" :class="{ active: num == 4 }" @click="num = 4">
          积分
        </div>
      </div>
      <div>
        <div class="goods">
          <img src="static/img/icon3.png" class="pic" alt="" />
          <div style="width: 100%">
            <p style="word-break: break-all; font-weight: bold">
              积分——文明云一比一兑换最江阴积分
            </p>
            <p style="font-size: 14px">
              兑换时间:3月27日起每周三上午10点至下午24点1:1兑换积分
            </p>
          </div>
          <div
            style="
              white-space: nowrap;
              font-size: 14px;
              display: flex;
              flex-direction: column;
              justify-content: center;
            "
          >
            <div class="bt" style="color: white" @click="show = true">兑换</div>
          </div>
        </div>
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多啦"
          :immediate-check="false"
          @load="load_more"
        >
          <div
            class="goods"
            v-for="(item, index) in list"
            :key="index"
            @click="
              $router.push({ name: 'jfgoodsdetail', query: { id: item.id } })
            "
          >
            <img :src="item.cover" class="pic" alt="" />
            <div style="width: 100%">
              <p style="word-break: break-all; font-weight: bold">
                {{ item.title }}
              </p>
              <p style="font-size: 14px">兑换时间:{{ item.begintime_str }}</p>
              <p style="margin-top: 10px; color: #dfbd91">
                {{ item.score }}积分
              </p>
            </div>
            <div
              style="
                white-space: nowrap;
                font-size: 14px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
              "
            >
              <p style="text-align: right">剩余{{ item.storage }}件</p>
              <div
                class="bt"
                style="color: white"
                v-if="timest() > item.begintime && item.storage > 0"
                @click.stop="exchange(item)"
              >
                兑换
              </div>
              <div
                class="bt"
                v-else-if="timest() > item.begintime && item.storage <= 0"
                style="background: #858585; color: white"
              >
                已抢光
              </div>
              <div
                class="bt"
                v-else
                style="
                  background: #f8f6ef;
                  color: #cab586;
                  border: 1px solid #cab586;
                "
              >
                即将开放
              </div>
            </div>
          </div>
        </van-list>
      </div>
    </div>
    <!-- dialog -->
    <van-dialog
      v-model="show"
      title="积分兑换"
      show-cancel-button
      class="jifendialog"
      :before-close="beforeClose"
    >
      <p>请输入要兑换的最江阴积分数量：</p>
      <van-field v-model.trim="jf" type="digit" />
      <p>（一比一兑换）</p>
    </van-dialog>
  </div>
</template>
<script>
import { Dialog } from "vant";
export default {
  name: "jfcenter",
  data() {
    return {
      value: "",
      num: 1,
      mypoint: "",
      list: [],
      loading: false,
      finished: false,
      page: 1,
      type: "",
      headimg: "",
      show: false,
      jf: "",
    };
  },
  watch: {
    num: {
      handler: function (val) {
        if (val == 1) {
          this.type = "";
          this.list = [];
          this.page = 1;
          this.loading = false;
          this.finished = false;
          this.init();
        } else if (val == 2) {
          this.type = "1";
          this.list = [];
          this.page = 1;
          this.loading = false;
          this.finished = false;
          this.init();
        } else if (val == 3) {
          this.type = "2";
          this.list = [];
          this.page = 1;
          this.loading = false;
          this.finished = false;
          this.init();
        } else if (val == 4) {
          this.type = "3";
          this.list = [];
          this.page = 1;
          this.loading = false;
          this.finished = false;
          this.init();
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.$axios({
      method: "post",
      url: "/api/score/index",
    }).then((res) => {
      this.list = res.data.data.list;
      this.mypoint = res.data.data.myscore;
    });
    this.$axios({
      method: "post",
      url: "/api/home/index",
    }).then((res) => {
      if (res.data.data.member.img == "") {
        this.headimg = "static/img/icon3.png";
      } else {
        this.headimg = res.data.data.member.img;
      }
    });
  },
  methods: {
    beforeClose: function (action, done) {
      // 点击事件 - 备注按钮提示框
      if (action === "confirm") {
        if (this.jf.length == 0) {
          this.$toast("请输入需要兑换的数量");
          done(false);
        } else {
          this.$toast.loading({
            duration: 0,
            forbidClick: true,
          });
          this.$axios
            .post(
              "/api/score/zjy_score",
              this.qs.stringify({
                zjy_score: this.jf,
              })
            )
            .then((res) => {
              this.$toast.clear();
              if (res.data.code != 0) {
                Dialog({ message: res.data.msg });
                done(false);
              } else {
                done();
                Dialog({ message: "兑换成功" });
              }
            });
        }
      } else if (action === "cancel") {
        // 取消
        done(); // 关闭提示框
      }
    },
    checkres() {
      this.list = [];
      this.page = 1;
      this.loading = false;
      this.finished = false;
      this.init();
    },
    load_more() {
      this.page += 1;
      var that = this;
      setTimeout(function () {
        that
          .$axios({
            method: "post",
            url: "/api/score/index",
            data: that.qs.stringify({
              keyword: that.value,
              page: that.page,
              type: that.type,
            }),
          })
          .then((res) => {
            console.log(res.data);
            if (res.data.code == 0) {
              that.list = that.list.concat(res.data.data.list);
            }
            that.loading = false;
            if (res.data.data.list.length == 0) {
              //数据全部加载完成
              that.finished = true;
            } else {
              that.finished = false;
            }
          });
      }, 500);
    },
    init() {
      this.$axios({
        method: "post",
        url: "/api/score/index",
        data: this.qs.stringify({
          page: this.page,
          keyword: this.value,
          type: this.type,
        }),
      }).then((res) => {
        this.list = res.data.data.list;
        this.mypoint = res.data.data.myscore;
      });
    },
    timest() {
      var tmp = Date.parse(new Date()).toString();
      tmp = tmp.substr(0, 10);
      return tmp;
    },
    exchange(item) {
      Dialog.confirm({
        title: "提示",
        message: "是否确认兑换该商品",
      })
        .then(() => {
          // on confirm
          this.$toast.loading({
            duration: 0,
            forbidClick: true,
          });
          this.$axios({
            method: "post",
            url: "/api/score/beforebuy",
            data: this.qs.stringify({
              good_id: item.id,
            }),
          }).then((res) => {
            this.$toast.clear();
            if (res.data.code != 0) {
              this.$toast(res.data.msg);
            } else {
              this.$axios({
                method: "post",
                url: "/api/score/buy",
                data: this.qs.stringify({
                  good_id: item.id,
                }),
              }).then((res) => {
                if (res.data.code != 0) {
                  this.$toast(res.data.msg);
                } else {
                  this.list = [];
                  this.page = 1;
                  this.loading = false;
                  this.finished = false;
                  this.init();
                  this.$forceUpdate();
                  this.$toast("兑换成功");
                }
              });
            }
          });
        })
        .catch(() => {
          // on cancel
        });
    },
  },
};
</script>
<style scoped>
.container {
  background: #f5f5f5;
  min-height: 100vh;
}
.top {
  padding: 15px;
  background: #cab586;
  color: white;
  display: flex;
  padding-right: 0;
}
.avatar {
  width: 65px;
  height: 65px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 16px;
  flex-shrink: 0;
}
.dhbt {
  color: #cab586 !important;
  background: white;
  width: 94px;
  height: 30px;
  line-height: 30px;
  font-size: 14px;
  text-align: center;
  border-radius: 25px 0px 0px 25px;
  margin-left: auto;
}
.main {
  background: white;
  padding: 15px;
  margin-top: 15px;
}
.flex {
  display: flex;
  justify-content: space-between;
}
.tab {
  width: 80px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: #f5f5f5;
  font-size: 14px;
  border-radius: 20px;
}
.active {
  color: #cab586;
}
.goods {
  display: flex;
  margin: 10px 0;
}
.pic {
  width: 73px;
  height: 73px;
  object-fit: cover;
  border-radius: 15px;
  flex-shrink: 0;
  margin-right: 10px;
}
.bt {
  width: 80px;
  height: 30px;
  background: #cab586;
  border-radius: 20px;
  text-align: center;
  line-height: 30px;
  align-self: self-end;
}
.jifendialog p {
  padding: 10px;
}
.jifendialog /deep/ .van-cell {
  width: calc(100% - 20px);
  display: block;
  margin: 0 auto;
  padding: 10px 0;
  background: #eee;
}
.jifendialog /deep/ .van-cell input {
  text-indent: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/jfcenter.vue